export const translationEnGb = {
	globals: {
		title_header: 'RUMI - Registre unificat de maltractament infantil',
		anterior: 'Anterior',
		seguent: 'Següent',
		imprimir: 'Imprimir',
		tancar: 'Tancar'
	},
	home: {
		benvinguda: 'BENVINGUT/UDA al Sistema de suport a la gestió del risc social en la infància i l\'adolescència',
		que_es: 'Què és el sistema?',
		que_preten: 'Què pretén?',
		que_permet: 'Què permet?',
		com_funciona: 'Com funciona?',
		simulacio: 'Simulació'
	},
	inici_simulacio: {

	},
	questionari_observacions: {

	},
	apreciacio_gravetat: {

	},
	valoracions_finals: {

	},
	altres_observacions: {

	},
	resultat_risc: {

	},
	accions: {

	}
};
